import * as React from "react";
import { useTranslation } from "react-i18next";
import { Alert } from "components/bootstrap";
const FetchErrorAlert = ({ message, error = null }) => {
  var _a;
  const { t } = useTranslation("common");
  return /* @__PURE__ */ React.createElement(Alert, { bsStyle: "danger" }, t("errors.fetch_error", { message, error: (_a = error == null ? void 0 : error.message) != null ? _a : t("errors.unknown_error") }));
};
export default FetchErrorAlert;
